<template>
    <div class="field-table flex-1 flex flex-col  max-h-full max-w-full  min-h-full text-base-content">
        <!-- <SubHeader  
            class="mx-6" 
            :backButton="true" 
            :backRedirectionUrl="`/credit-packs?tab=summary`" 
            :customCrumbLists="customBreadCrumbs"
        /> -->
        <div class="flex relative flex-1 flex-col flex-grow max-h-full max-w-full">
            <vue-good-table  
                :columns="columns" 
                :isLoading="loading" 
                :rows="rowsData" 
                :pagination-options="{ enabled: true, mode: 'records', dropdownAllowAll: false,}" 
                :totalRows="pageData.total_count"
                @on-page-change="onPageChange($event)"
                @on-per-page-change="onPageChange($event, true)"
                >
                <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field === 'unique_id'" class="flex gap-3 pl-3">
                        {{ props.row.unique_id}}
                    </div>
                     <div v-if="props.column.field == 'analyst'" class="flex justify-center">
                        {{props.row.analyst}}
                    </div>
                    <div v-if="props.column.field == 'case_id'" class="flex justify-center">
                        {{props.row.case_id}}
                    </div>
                    <div v-if="props.column.field == 'date'" class="flex justify-center">
                        {{ props.row.date ? FormatDate(new Date(props.row.date)) : '-'}}
                    </div>
                    <div v-if="props.column.field == 'credit_used'" class="flex justify-center">
                        {{ props.row.credit_used }}
                    </div>
                    <div v-if="props.column.field == 'source'" class="flex justify-center">
                        {{ props.row.source }}
                    </div>
                    <div v-if="props.column.field == 'service_charge'" class="flex justify-center">
                        {{ props.row.service_charge }}
                    </div>
                    <div v-if="props.column.field == 'query'" class="flex justify-center capitalize">
                        <svg @click="queryinfo(props.row.query)" width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect y="2" width="18" height="18" rx="9" fill="#0D69D5"/>
                            <path d="M9.50539 8.84C9.20539 8.84 8.95872 8.75333 8.76539 8.58C8.57872 8.4 8.48539 8.18 8.48539 7.92C8.48539 7.65333 8.57872 7.43333 8.76539 7.26C8.95872 7.08 9.20539 6.99 9.50539 6.99C9.79872 6.99 10.0387 7.08 10.2254 7.26C10.4187 7.43333 10.5154 7.65333 10.5154 7.92C10.5154 8.18 10.4187 8.4 10.2254 8.58C10.0387 8.75333 9.79872 8.84 9.50539 8.84ZM10.3554 9.42V15H8.64539V9.42H10.3554Z" fill="white"/>
                        </svg>
                    </div>
                </template>

                <template #loadingContent>
                    <div class="w-full py-10 justify-center flex">
                        <Loader />
                    </div>
                </template>
            </vue-good-table>
            <!-- <button 
                v-if="isFilters"
                class=" cursor-pointer py-1 px-3 bg-gray-100 hover:bg-gray-200 rounded-md text-xs text-black flex justify-center items-center font-semibold absolute z-50 left-2" :class="isSelectionChanged ? 'top-14' : 'top-2' " @click="clearFilters">
                Clear filters
            </button> -->
            <Modal ref="Query-info" title='Query' :showFooter='false'> 
                <template #content>
                    <div class="grid gap-2"> 
                        <span class="border-b text-bold" >{{ query }}</span>
                    </div>
                </template>
            </Modal>
        </div>
    </div>
</template>
<script>
    import {getCreditsUsage, getQuery} from "../../services"
    import Loader from "@/components/loader";
    import Modal from "@/components/modal-content"
    import {FormatDate} from "@/plugins/functions"

    export default {
        name: "credit-packs",
        title: "Credit Admin",
        components: {
            Loader,
            Modal,
        },
        data() {
            return {
                columns: [  
                    { 
                        label: "Pack Unique Id", 
                        field: "unique_id",
                        filterOptions: {
                            enabled: true,
                        }, 
                    },
                    { 
                        label: "Analyst", 
                        field: "analyst",
                        filterOptions: {
                            enabled: true,
                        },  
                    },
                    { 
                        label: "Date", 
                        field: "date",
                        filterOptions: {
                            enabled: true,
                            filterFn: this.dateFilterFn,
                        },  
                    },
                    { 
                        label: "Case Id", 
                        field: "case_id",
                        filterOptions: {
                            enabled: true,
                        },  
                    },
                    { 
                        label: "Source", 
                        field: "source",
                        filterOptions: {
                            enabled: true,
                        },  
                    },
                    { 
                        label: "Credit Used", 
                        field: "credit_used",
                        filterOptions: {
                            enabled: true,
                        },  
                    },
                    // { 
                    //     label: "Service Charge", 
                    //     field: "service_charge",
                    //     filterOptions: {
                    //         enabled: true,
                    //     },  
                    // }, 
                    // { 
                    //     label: "Query", 
                    //     field: "query",  
                    // }, 

                ],
                rowsData: [],
                pageData: {
                    total_pages: 0,
                },
                currentPageData: {
                    page: 1,
                    count: 10,
                },
                loading: false,
                query: null,
                
            }
        },
        async mounted() {
            this.loading = true
            await this.setCreditPacks()
            this.loading = false

        },
        methods: {
            FormatDate,
            async setCreditPacks()
            {   
                const qParams = `${this.$route.params.id}&page=${this.currentPageData.page}&limit=${this.currentPageData.count}`
                const {data} = await getCreditsUsage(qParams)
                this.rowsData = data.credit_packs_usage
                this.pageData = data?.pagination_info;
            },
            getStatusColor(status) {
                if (status.toLowerCase() == "in use") {
                    return "text-yellow-500"
                }
                if (status.toLowerCase() == 'active') {
                    return 'text-green-400'
                }
            },
            async queryinfo(query){
                try {
                    const { data } = await getQuery(query)
                    this.query =  data
                    this.$refs["Query-info"].showModal();
                } catch(error) {
                    console.log('err', error);
                }
            },
            async onPageChange(data, resetPage = false) {
                this.currentPageData = {
                    page: data.currentPage,
                    count: data.currentPerPage,
                };
                if (resetPage) this.currentPageData.page = 1;
                await this.setCreditPacks();
            },
            dateFilterFn(data, filterString) {
                let givenDate = FormatDate(new Date(data)).toLowerCase();
                return givenDate.includes(filterString.toLowerCase());
            }
        }

    }
</script>


